export default __webpack_public_path__ + "static/media/lp-enigma.b036b92a.png";